module.exports = __webpack_public_path__ + "static/media/15-Hannover@3x.a7553ab1.jpg";